import React , { useRef }from 'react'
import right from "../../assets/svg/right.svg"
import left from "../../assets/svg/left.svg"
import search from "../../assets/svg/search.svg"
import filter from "../../assets/svg/filter.svg"
import defalt from "../../assets/svg/default.svg"
import filter1 from "../../assets/svg/filter1.svg"
import filter2 from "../../assets/svg/filter2.svg"
import { DList } from '../../Constent/Constent'

const Docks = () => {
    const scrollRef = useRef(null);
    const handleScroll = (dir) => {
        const scrollAmount = 200;
        if (scrollRef.current) {
          scrollRef.current.scrollBy({
            left: dir === 'left' ? -scrollAmount : scrollAmount,
            behavior: 'smooth',
          });
        }}
    const datas = Array(9).fill({
        vehicleNumber: 'TN 45 AV 9419',
        driverName: 'Purushothaman',
        date: '23-03-2023',
        dockIn: '09:00 AM',
        dockOut: '--:--',
        duration: '01:32:54 hrs',
        status: 'Queue',
      });
    
      const statusOptions = ['Queue', 'Dock In', 'Over Time', 'Delay', 'Dock Out'];

  return (
    <div className='content_container'>
        
        <div className="d_series">
            <button type="button" className='d_sers_btn' onClick={() => handleScroll('left')}> 
                <img src={left} alt="left" srcset="" />
            </button>
            <span className='scroller' ref={scrollRef}>{
                DList.map((item)=> <div className='D_div' key={item.id}>
                <p className='D_head'>{item.name}</p>
                <p className='D_text'>{item.isAvailable ? 'Available':' Available'}</p>
            </div>)
            }</span>
           
            <button type="button" className='d_sers_btn'onClick={() => handleScroll('right')}> 
                <img src={right} alt="right" srcset="" />
            </button>

        </div>
        <div className="dock_filter">
            <div className="left_fill">
                <button type="button" className='fill_btn' style={{backgroundColor:"#D35258",color:"#FFFFFF"}}>All</button>
                <button type="button" className='fill_btn'>Queue</button>
                <button type="button" className='fill_btn'>Dock in</button>
                <button type="button" className='fill_btn'>Overtime</button>
                <button type="button" className='fill_btn'>Delay</button>
                <button type="button" className='fill_btn'>Dock out</button>
            </div>
            <div className="right_fil">
                <div className='right_btn'><img src={search} alt=""  style={{width:"24px",height:"24px"}}/> <input type="text" placeholder='Search..' className='right_btn_searchbar' /></div>
                <div className='right_btn'> <img src={defalt} alt="" /><span>Default (datas created)</span></div>
                <div className='right_btn'> <img src={filter} alt="" /><span>Filter</span></div>
                
                <div className='right_btn'> 
                    <img src={filter1} alt="filter1" />
                    <span className="vr-line"></span>
                    <img src={filter2} alt="filter2" />
                </div>
            </div>
        </div>
        <div className="table-responsive">
      <table className="table table-bordered align-middle text-center">
        <thead className="table-light">
          <tr>
            <th>
              <input type="checkbox" />
            </th>
            <th>Vehicle Number</th>
            <th>Driver Name</th>
            <th>Date</th>
            <th>Dock In Time</th>
            <th>Dock Out Time</th>
            <th>Status</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {datas.map((data, i) => (
            <tr key={i}>
              <td>
                <input type="checkbox" />
              </td>
              <td style={{fontWeight:"600",fontSize:"14px"}}>{data.vehicleNumber}</td>
              <td>{data.driverName}</td>
              <td>{data.date}</td>
              <td>{data.dockIn}</td>
              <td>{data.dockOut}</td>
              <td>
                <select className="form-select form-select-sm w-auto mx-auto">
                  {statusOptions.map((option, idx) => (
                    <option key={idx} selected={option === data.status}>
                      {option}
                    </option>
                  ))}
                </select>
              </td>
              <td>{data.duration}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  )
}

export default Docks